<template>
  <div
    v-if="isAndroid"
    ref="element"
    class="fixed bottom-0 left-0 right-0 pointer-events-none"
    :class="!isBarWithoutButtons && 'bg-white'"
    style="z-index: 999999"
  >
    <div class="safe-margin-bottom" />
  </div>
</template>

<script setup lang="ts">
const { platform } = useDevice()

const isAndroid = platform === Device.Android

const element = ref<HTMLElement | null>(null)
const isBarWithoutButtons = ref(false)
let resizeObserver: ResizeObserver | null = null

onMounted(() => {
  if (!isAndroid) {
    return
  }

  // it was noticed that when navigating to Event Hub, safe area variables are not filled immediately,
  // for stability we use ResizeObserver
  resizeObserver = new ResizeObserver((entries: ResizeObserverEntry[]) => {
    isBarWithoutButtons.value =
      entries[0].target.getBoundingClientRect().height < 40
  })

  resizeObserver.observe(element.value!)
})

onUnmounted(() => {
  resizeObserver?.disconnect()
  resizeObserver = null
})
</script>
